import { render, staticRenderFns } from "./bigImg.vue?vue&type=template&id=75ca6778&scoped=true&"
import script from "./bigImg.vue?vue&type=script&lang=js&"
export * from "./bigImg.vue?vue&type=script&lang=js&"
import style0 from "./bigImg.vue?vue&type=style&index=0&id=75ca6778&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca6778",
  null
  
)

export default component.exports